let session;

try {
    session = window.sessionStorage;
} catch {
    session = null;
}

export const validateEmail = value => {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        return false;
    }

    return true;
};

export const payOptions = [
    { lbl: 'Vipps', value: 'vipps', selected: true },
    { lbl: 'Visa', value: 'visa', selected: false },
    { lbl: 'Mastercard', value: 'mastercard', selected: false }
];

export const personInfo = {
    fName: '',
    lName: '',
    email: '',
    phoneNumber: '',
    streetName: '',
    postalVal: '',
    postArea: '',
    country: 'Norge'
};

export const formData = {
    ...personInfo,
    modelAmount: 1,
    payOptions,
    postalVal: '',
    postArea: '',
    giftValue: 250,
    optionList: []
};

export const otherPersonInfo = {
    name: '',
    nokinMsg: '', // nok = Next of Kin
    nokName: '',
    streetName: '',
    postalVal: '',
    postArea: '',
    country: 'Norge',
    nextEvent: '',
    eventTime: ''
};

export const giftEvents = [
    { value: 'Bursdag' },
    { value: 'Julegave' },
    { value: 'Bryllup' },
    { value: 'Konfirmasjon' },
    { value: 'Morsdag' },
    { value: 'Farsdag' },
    { value: 'Dåp' },
    { value: ' ', label: '...Eller skriv annen anledning' }
];

export const mapEventsValue = val => {
    if (val && typeof val === 'string') {
        val = val.toLowerCase();
        return (
            {
                bursdag: '5',
                bryllup: '3',
                julegave: '2'
            }[val] || '8'
        );
    }

    return '';
};
export const mottakerTekst = {
    Bursdag: 'jubilanten',
    Bryllup: 'brudeparet',
    Konfirmasjon: 'konfirmanten',
    Morsdag: 'mor',
    Farsdag: 'far',
    Dåp: 'dåpsbarnet'
};

export const memberValor = {
    N: 'Støttemedlem',
    B: 'Bronsemedlem',
    S: 'Sølvmedlem',
    G: 'Gullmedlem'
};

export const memberBetalingsM = {
    G: 'Giro',
    AG: 'AvtaleGiro',
    EF: 'eFaktura',
    VF: 'Vipps (trekkes direkte månedlig via Vipps)'
};

export const memberaFrekvens = {
    1: 'årlig',
    12: 'Månedlig',
    2: 'halv årlig',
    4: 'kvartalsvis'
};

export const removeInSession = field => {
    if (session) {
        session.removeItem(field);
    }
};
export const findInSession = field => {
    return session ? session.getItem(field) : null;
};
export const setInSession = (field, value) => {
    if (session) {
        session.setItem(field, value);
    }
};
export const getInitFormData = (paymentInfo, form) => {
    const formD = form && form === 'symbolic' ? { ...formData, selProds: [] } : formData;

    if (!paymentInfo) {
        return formD;
    }

    const paymentOption = paymentInfo.betm.toLowerCase();

    const newPayOptions = payOptions.map(({ lbl, value }) => ({
        lbl,
        value,
        selected: value === paymentOption
    }));

    return {
        ...formD,
        payOptions: newPayOptions,
        modelAmount: paymentInfo.prod1_antall,
        phoneNumber: paymentInfo.ho_mobilnr,
        fName: paymentInfo.ho_fnavn,
        lName: paymentInfo.ho_enavn,
        streetName: paymentInfo.adresse1,
        postalVal: paymentInfo.postnr,
        email: paymentInfo.ho_epost
    };
};
export const remapData = (user, formData) => {
    return {
        ...formData,
        fName: user.ho_fnavn || formData.fName,
        lName: user.ho_enavn || formData.lName,
        streetName: user.adresse1 || formData.streetName,
        postalVal: user.postnr || formData.postalVal,
        postArea: user.poststed || formData.postArea,
        email: user.ho_epost || formData.email
    };
};

export const updateFormDataWithPhoneNo = (response, formData, doIt) => {
    doIt({
        ...formData,
        phoneNumber: response.mobilnr || formData.phoneNumber,
        fName: response.fornavn || formData.fName,
        lName: response.etternavn || formData.lName,
        streetName: response.adresse || formData.streetName,
        postalVal: response.postnr || formData.postalVal,
        postArea: response.poststed || formData.postArea,
        country: response.land && response.land !== '' ? response.land : formData.country
    });
};
export const updateFormData = (response, formData, doIt) => {
    doIt({
        ...formData,
        fName: response.fornavn || formData.fName,
        lName: response.etternavn || formData.lName,
        streetName: response.adresse1 || response.adresse || formData.streetName,
        postalVal: response.postnr || formData.postalVal,
        email: response.epost || formData.email,
        postArea: response.poststed || formData.postArea,
        country: response.land && response.land !== '' ? response.land : formData.country
    });
};
export const validSsn = fodselsnr => {
    fodselsnr = fodselsnr.replace(/\s/g, '');

    if (fodselsnr.length !== 11) {
        return false;
    }

    function sum(birthNumber, factors) {
        return factors.reduce(function (sum, factor, i) {
            return sum + parseInt(birthNumber.charAt(i), 10) * factor;
        }, 0);
    }

    const arr1 = [3, 7, 6, 1, 8, 9, 4, 5, 2, 1];
    const arr2 = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2, 1];
    const chk1 = sum(fodselsnr, arr1);
    const chk2 = sum(fodselsnr, arr2);

    const mod1 = chk1 % 11;
    const mod2 = chk2 % 11;

    return mod1 === 0 && mod2 === 0;
};

export const standardGiftSums = [
    { value: 200, label: '200 kr', isDefault: true },
    { value: 250, label: '250 kr', isDefault: false },
    { value: 300, label: '300 kr', isDefault: false },
    { value: 400, label: '400 kr', isDefault: false }
];

export const standardSupportSums = [
    { value: 150, label: '150 kr', isDefault: false },
    { value: 250, label: '250 kr', isDefault: true },
    { value: 500, label: '500 kr', isDefault: false }
];

export const productCodes = {
    '00': 'kalendre',
    1: 'førstehjelpspakker',
    45: 'bamser',
    14: 'jubileumsbøker',
    24: 'modelhelikoptere',
    43: 'bilpakker',
    44: 'varmetepper'
};

export const standardProductSums = [
    { value: '2 900', number: 3, isDefault: true },
    { value: '6 900', number: 8, isDefault: false },
    { value: '11 900', number: 15, isDefault: false }
];
